import {
  SET_OFFERS,
  REMOVE_OFFER,
  SET_AGREEMENT,
  TOGGLE_OFFER
} from 'src/redux/actions/offers';
import { SET_CONTEXT } from 'src/redux/actions/context';


const initialState = {
  hasProfilingAgreement: true,
  processing: false,
  offers: []
};

const offersReducer = (state = initialState, { type, payload }) => ({
  [TOGGLE_OFFER]: () => ({
    ...state,
    offers: state.offers.map(offer => ({
      ...offer,
      isFavourite: offer.offerId === payload.offerId ? payload.isFavourite : offer.isFavourite
    }))
  }),
  [REMOVE_OFFER]: () => ({
    ...state,
    offers: state.offers.filter(({ offerId }) => offerId !== payload.offerId)
  }),
  [SET_OFFERS]: () => ({ ...state, ...payload, processing: false }),
  [SET_CONTEXT]: () => ({ ...state, processing: true }),
  [SET_AGREEMENT]: () => ({ ...state, ...payload })
}[type] || (() => state))();

export default offersReducer;
